import { render } from "./ParrillaLista.vue?vue&type=template&id=2819f4e0"
import script from "./ParrillaLista.vue?vue&type=script&lang=js"
export * from "./ParrillaLista.vue?vue&type=script&lang=js"

import "./ParrillaLista.vue?vue&type=style&index=0&id=2819f4e0&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__